import { activities } from "./activities/activities";
import { assignments } from "./assignments/assignments";
import { attempts } from "./attempts/attempts";
import { emails } from "./emails/emails";
import { inspection } from "./inspection/inspection";
import { issues } from "./issues/issues";
import { me } from "./me/me";
import { milestones } from "./milestones/milestones";
import { order } from "./order/order";
import { assignmentPreviews } from "./assignmentPreviews/assignmentPreviews";
import { assignmentTemplates } from "./assignmentTemplates/assignmentTemplate";
import { attemptTypes } from "./attemptTypes/attemptTypes";
import { buildTemplate } from "./buildTemplate/buildTemplate";
import { cannotPerformReasons } from "./cannotPerformReasons/cannotPerformReasons";
import { inspectionTemplates } from "./inspectionTemplates/inspectionTemplates";
import { issueTemplateOrderTemplateMaps } from "./issueTemplateOrderTemplateMaps/issueTemplateOrderTemplateMaps";
import { issueTemplates } from "./issueTemplates/issueTemplates";
import { issuesResults } from "./issuesResults/issuesResults";
import { labelConfig } from "./labelConfig/labelConfig";
import { milestoneOrdertypes } from "./milestoneOrdertype/milestoneOrdertype";
import { orderReasons } from "./orderReasons/orderReasons";
import { orderTemplateAssignmentTemplateMaps } from "./orderTemplateAssignmentTemplateMaps/orderTemplateAssignmentTemplateMaps";
import { orderTemplateCapacities } from "./orderTemplateCapacities/orderTemplateCapacities";
import { orderTemplates } from "./orderTemplates/orderTemplates";
import { reasonGroups } from "./reasonGroups/reasonGroups";
import { stepTemplates } from "./stepTemplates/stepTemplates";
import { suppressedWork } from "./suppressedWork/suppressedWork";
import { userCapacities } from "./userCapacities/userCapacities";
import { workOrderDependencyMaps } from "./workOrderDependencyMaps/workOrderDependencyMaps";
import { workOrderTemplateAssignmentTemplateMaps } from "./workOrderTemplateAssignmentTemplateMaps/workOrderTemplateAssignmentTemplateMaps";
import { workOrderTemplates } from "./workOrderTemplates/workOrderTemplates";
import { workOrders } from "./workOrders/workOrdersService.ts";

export const taskService = {
  assignments,
  issues,
  activities,
  attemptTypes,
  reasonGroups,
  attempts,
  issueTemplates,
  me,
  issuesResults,
  assignmentTemplates,
  issueTemplateOrderTemplateMaps,
  buildTemplate,
  milestones,
  milestoneOrdertypes,
  assignmentPreviews,
  order,
  inspection,
  orderTemplates,
  inspectionTemplates,
  orderReasons,
  orderTemplateCapacities,
  orderTemplateAssignmentTemplateMaps,
  labelConfig,
  workOrderTemplates,
  workOrderDependencyMaps,
  workOrderTemplateAssignmentTemplateMaps,
  suppressedWork,
  userCapacities,
  stepTemplates,
  emails,
  workOrders,
  cannotPerformReasons,
};
